import { useMediaQuery, Icon, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Marker } from 'react-map-gl';

import { IconLocationPinStart } from 'assets/icons';
import Mapbox from 'components/Mapbox';
import JobPolygon from 'components/Mapbox/JobPolygon';
import JobRadius from 'components/Mapbox/JobRadius';

interface IJobDetailMapProps {
  data: any;
}

const JobDetailMap: React.FC<IJobDetailMapProps> = ({ data }) => {
  const { t } = useTranslation(['jobsTasks', 'common']);

  const [isLargerThan768] = useMediaQuery(['(min-width: 768px)'], { ssr: false });
  const [mapView, setMapView] = useState<'street' | 'satellite'>('street');

  const handleMapViewChange = useCallback((nextValue: 'street' | 'satellite') => {
    setMapView(nextValue);
  }, []);

  return (
    <>
      <Mapbox
        initialViewState={{
          latitude: +data?.payload.latitude,
          longitude: +data?.payload.longitude,
          zoom: 13,
        }}
        style={{ width: '100%', height: isLargerThan768 ? '370px' : '300px' }}
        mapStyle={
          mapView === 'street' ? 'mapbox://styles/mapbox/streets-v11' : 'mapbox://styles/mapbox/satellite-streets-v9'
        }
      >
        <RadioGroup
          onChange={handleMapViewChange}
          value={mapView}
          position="absolute"
          top="10px"
          left="10px"
          p="1"
          px="2"
          bg="white"
          colorScheme="primary"
          fontWeight="semibold"
          borderRadius="lg"
        >
          <Stack direction="row" cursor="pointer">
            <Radio size="sm" value="street" mr="2">
              {t('common:street')}
            </Radio>
            <Radio size="sm" value="satellite">
              {t('common:satellite')}
            </Radio>
          </Stack>
        </RadioGroup>
        {data?.payload?.requireGeofence && !data?.payload.custom_geofence ? (
          <JobRadius
            radius={data?.payload.radius}
            latitude={data?.payload.latitude}
            longitude={data?.payload.longitude}
          />
        ) : null}

        {data?.payload?.requireGeofence &&
        data?.payload?.custom_geofence &&
        Array.isArray(data?.payload?.geofence_coordinates) ? (
          <JobPolygon coordinates={data?.payload?.geofence_coordinates || []} />
        ) : null}
        <Marker longitude={data?.payload?.longitude} latitude={data?.payload?.latitude} offset={[0, -5]}>
          <Icon as={IconLocationPinStart} fontSize="3xl" />
        </Marker>
      </Mapbox>
    </>
  );
};

export default JobDetailMap;
